<div *ngFor="let role of list">{{role}}</div>
